import Icon from '../components/Icon.vue'

Icon.register({"door-closed":{"width":640,"height":512,"paths":[{"d":"M624 448H512V50.8C512 22.8 490.5 0 464 0H176C149.5 0 128 22.8 128 50.8V448H16C7.2 448 0 455.2 0 464V496C0 504.8 7.2 512 16 512H624C632.8 512 640 504.8 640 496V464C640 455.2 632.8 448 624 448zM416 288C398.3 288 384 273.7 384 256S398.3 224 416 224 448 238.3 448 256C448 273.7 433.7 288 416 288z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/door-closed.js
// module id = ZMxN
// module chunks = 0